// import React, { useEffect, useState } from "react";
// import ProductCardimg from "../ShopProductCard/ProductCard";
// import './Final-related.css';
// import { getWithoutTokenAPI } from "../../util/Api";
// import { useSelector } from "react-redux";

// const RelatedProductsmy = ({ product }) => {
//   const [productList, setProductList] = useState([]);
//   const userId = useSelector((state) => state.auth?.auth?._id);

//   useEffect(() => {
//     const fetchProducts = async () => {
//       try {
//         // Only append user_id if it exists and is valid
//         const queryParams = userId && userId.length === 24 ? `?user_id=${userId}` : '';
//         const response = await getWithoutTokenAPI(`/product/find-all${queryParams}`);
//         if (response && response.statusCode === 200) {
//           // Attach sellerName and wish_status to each product
//           const products = response.data?.Product || [];
//           const updatedProducts = products.map(product => ({
//             ...product,
//             sellerName: product.seller_id?.name || "Unknown Seller",
//             wish_status: product.wish_status || false
//           }));
//           setProductList(updatedProducts);
//         }
//       } catch (error) {
//         console.error("Error fetching products:", error);
//       }
//     };

//     fetchProducts();
//   }, [userId]);

//   return (
//     <>
//       <h5 className="product-head-code">Related Products</h5>
//       <div className="related-products-container">
//         {productList
//           .slice(0, 5)
//           .filter((item) => item && item.product_image && item.product_image.length > 0)
//           .map((item) => (
//             <ProductCardimg 
//               key={item._id} 
//               product={{
//                 ...item,
//                 sellerName: item.sellerName || item.seller_id?.name || "Unknown Seller",
//                 name: item.name || "Product",
//                 wish_status: item.wish_status || false
//               }} 
//             />
//           ))}
//       </div>
//     </>
//   );
// };

// export default RelatedProductsmy;



import React, { useEffect, useState } from "react";
import ProductCardimg from "../ShopProductCard/ProductCard";
import './Final-related.css';
import { getWithoutTokenAPI } from "../../util/Api";
import { useSelector } from "react-redux";

const RelatedProductsmy = ({ product }) => {
  const [productList, setProductList] = useState([]);
  const userId = useSelector((state) => state.auth?.auth?._id);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        // Build query parameters
        let queryParams = [];
        
        // Add user_id if exists and is valid
        if (userId && userId.length === 24) {
          queryParams.push(`user_id=${userId}`);
        }
        
        // Always add approval status filter
        queryParams.push('Approval_status=Approval');
        
        // Join parameters with '&'
        const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
        
        const response = await getWithoutTokenAPI(`/product/find-all${queryString}`);
        
        if (response && response.statusCode === 200) {
          // Attach sellerName and wish_status to each product
          const products = response.data?.Product || [];
          const updatedProducts = products.map(product => ({
            ...product,
            sellerName: product.seller_id?.name || "Unknown Seller",
            wish_status: product.wish_status || false
          }));
          setProductList(updatedProducts);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, [userId]);

  return (
    <>
      <h5 className="product-head-code">Related Products</h5>
      <div className="related-products-container">
        {productList
          .slice(0, 5)
          .filter((item) => item && item.product_image && item.product_image.length > 0)
          .map((item) => (
            <ProductCardimg 
              key={item._id} 
              product={{
                ...item,
                sellerName: item.sellerName || item.seller_id?.name || "Unknown Seller",
                name: item.name || "Product",
                wish_status: item.wish_status || false
              }} 
            />
          ))}
      </div>
    </>
  );
};

export default RelatedProductsmy;
